module.exports = __webpack_public_path__ + "static2024-7-11/img/current-red-tag.3892d1f7.gif";